import { FC, KeyboardEvent } from 'react';
import './EventUrlEditModal.scss';
import { Dialog, DialogActions, DialogContent, TextField, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface EventUrlEditModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (text: string, url: string) => void;
  initialUrl?: string;
  initialText?: string;
}

const EventUrlEditModal: FC<EventUrlEditModalProps> = ({
  open,
  onClose,
  onSubmit,
  initialUrl = '',
  initialText = '',
}) => {
  const { t } = useTranslation();
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const text = formData.get('text') as string;
    const url = formData.get('url') as string;

    const fullUrl = url.match(/^https?:\/\//) ? url : `http://${url}`;
    onSubmit(text, fullUrl);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      event.stopPropagation();
      const form = event.currentTarget.closest('form');
      if (form) {
        const submitEvent = new Event('submit', { cancelable: true, bubbles: true });
        form.dispatchEvent(submitEvent);
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className="event-url-edit-modal">
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <div className="event-url-edit-modal__content">
            <TextField
              name="text"
              label={t('calendar.eventMenu.text')}
              fullWidth
              defaultValue={initialText}
              size="small"
              className="event-url-edit-modal__input"
              onKeyDown={handleKeyDown}
            />
            <TextField
              name="url"
              label={t('calendar.eventMenu.linkToUrlAddress')}
              fullWidth
              defaultValue={initialUrl}
              size="small"
              className="event-url-edit-modal__input"
              onKeyDown={handleKeyDown}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            {t('calendar.common.cancel')}
          </Button>
          <Button type="submit" variant="contained" color="primary">
            {t('calendar.common.ok')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EventUrlEditModal;
